import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface AddOAuthClientParams {
    dbClass: string;
    instanceUrl: string;
    clientId: string;
    clientSecret: string;
    redirectUri: string;
}

export interface AddOAuthClientsParams {
  oauthClients: AddOAuthClientParams[];
}

export class AddOAuthClientsRequest extends Request<AddOAuthClientsParams, IResult> {
  constructor(params: AddOAuthClientsParams) {
    super('addOAuthClients', params);
  }
}
